import React from 'react';
import {Cell, Legend, Pie, PieChart, ResponsiveContainer, Tooltip} from 'recharts';

interface ActivityChartProps {
  activeFishermen: number;
  totalMembers: number;
  reportedCatchYears: number;
}

export const ActivityChart = ({activeFishermen, totalMembers, reportedCatchYears}: ActivityChartProps) => {
  const chartData = [
    {name: 'Aktiv gefischt', value: activeFishermen},
    {name: 'Inaktiv', value: totalMembers - activeFishermen}
  ];

  const COLORS = ['#3b82f6', '#e5e7eb'];

  const activityRate = ((activeFishermen / totalMembers) * 100).toFixed(1);

  return (
    <div className="card h-100">
      <div className="card-header">
        <h3 className="card-title">Mitglieder-Aktivität</h3>
      </div>
      <div className="card-body">
        <ResponsiveContainer width="100%" height={300}>
          <PieChart>
            <Pie
              data={chartData}
              dataKey="value"
              nameKey="name"
              cx="50%"
              cy="50%"
              innerRadius={60}
              outerRadius={100}
              paddingAngle={2}
            >
              {chartData.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
              ))}
            </Pie>
            <Tooltip />
            <Legend />
          </PieChart>
        </ResponsiveContainer>
        <div className="mt-3 text-center">
          <div className="text-muted">
            <strong>{activeFishermen}</strong> von <strong>{totalMembers}</strong> Mitgliedern ({activityRate}%)
          </div>
          <div className="text-muted mt-2">
            Fangjahr gemeldet: <strong>{reportedCatchYears}</strong> Mitglieder
          </div>
        </div>
      </div>
    </div>
  );
};
